import React, { Component } from 'react'
import appStore from '~/assets/images/app-store.png'
import googlePlay from '~/assets/images/google-play.png'
import fireTv from '~/assets/images/fire-tv.png'
import appleTv from '~/assets/images/apple-tv.png'
import _ from 'lodash'
import './Footer04.scss'

class Footer04 extends Component {
  state = {
    links: _.get(window.settings, 'navigation.footer'),
    socialLinks: _.pickBy(_.get(window.settings, 'socialMedia'), link => link.url),
    address: _.get(window.settings, 'navigation.settings.footerAddress'),
  }

  componentDidMount = () => {
    this.setFooterHeight()
    window.addEventListener('resize', this.setFooterHeight);
  }
 
  setFooterHeight = () => {
    this.setState({
      footerPusher: document.querySelector('.footer04__content').clientHeight + 30
    });
  }

  get footerStyle() {
    return {
      backgroundColor: _.get(window.settings, "brand.footer.backgroundColor")
    }
  }

  get footerPusherStyle() {
    return {
      backgroundColor: _.get(window.settings, "brand.footer.backgroundColor"),
      height: `${this.state.footerPusher}px`
    }
  }

  redirectFooterItem(e, item) {
    if(item.title.toLowerCase() == 'send us feedback') {
      e.currentTarget.href = 'mailto:info@neoufitness.com';
    } else {
      e.currentTarget.href = item.url;
    }
  }

  render() {
    const { address, links } = this.state
    return (
      <div className="footer04">
        <div className='footer04__pusher' style={this.footerPusherStyle} />
        <div className="footer04__content" style={this.footerStyle}>
          <div className="footer-main">
            <div className="links">
              <ul>
                { links.map((l, i) => (
                  <li key={i}>
                    <a onClick={(e) => this.redirectFooterItem(e, l)}>{l.title}</a>
                  </li> 
                )) }
              </ul>
            </div>
            <div className="download-app">
              <div className="phone-wrapper">
                <a href={`https://itunes.apple.com/sa/app/neo-u/id1436991935?mt=8&ign-mpt=uo%3D2`} target="_blank">
                  <img src={appStore} alt="appstore download" />
                </a>
                <a href={`https://play.google.com/store/apps/details?id=com.neou.fitness`} target="_blank">
                  <img src={googlePlay} alt="google play download"/>
                </a>
              </div>
              <div className="tv-wrapper">
              <a href={`https://www.amazon.com/RhinoCo-NEO-U/dp/B07JLSCJVT?keywords=neo+u&qid=1540589241&s=STRING%28mas-store-name%29&sr=1-1&ref=sr_1_1`} target="_blank">
                  <img src={fireTv} alt="fire tv download" />
                </a>
                <a href={`https://itunes.apple.com/us/app/neo-u/id1436991935?mt=8`} target="_blank">
                  <img src={appleTv} alt="apple tv download" />
                </a>
              </div>
            </div>
            <div className="bottom-section">
              <div className="company-address">{address}</div>
              <div className="copyright">
                {`Copyright © ${new Date().getFullYear()} ${window.settings.companyName}`}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer04